module.exports = __webpack_public_path__ + "img/logo.1627c85b.svg";